export const PAYMS_PAYMENT_GATEWAY_BILLPLZ = 'BILLPLZ';
export const PAYMS_PAYMENT_GATEWAY_IPAY88 = 'IPAY88';
export const PAYMS_PAYMENT_GATEWAY_RAZERPAY = 'RAZERPAY';



// WEBPACK FOOTER //
// ./src/constants/payments.js